import { render } from "./EventBanner.vue?vue&type=template&id=00b7d99f&scoped=true"
import script from "./EventBanner.vue?vue&type=script&lang=js"
export * from "./EventBanner.vue?vue&type=script&lang=js"

import "./EventBanner.vue?vue&type=style&index=0&id=00b7d99f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b7d99f"]])

export default __exports__